import PortalMarketplace from '@/components/marketplace/PortalMarketplace'

export default function AdminShop() {
  return (
    <PortalMarketplace
      role="admin"
      title="Admin Marketplace"
      subtitle="Earn Tower Credits by resolving tickets and moderating forums. Spend them here."
    />
  )
}
